import APIService from '@/services/APIService.js';

export default {
  getAnaliticosCA(idCalculo) {
    return APIService.apiCall().get(`/calculoCaAneelAnaliticos/getAnaliticosCA/${idCalculo}`);
  },
  salvar(idCalculo, postData) {
    return APIService.apiCall().post(`/calculoCaAneelAnaliticos/salvar/${idCalculo}`, JSON.stringify(postData));
  },
  deletar(id) {
    return APIService.apiCall().get(`/calculoCaAneelAnaliticos/excluir/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/calculoCaAneelAnaliticos/executar/${id}`);
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/calculoCaAneelAnaliticos/baixarPlanilha/${id}`, { responseType: 'blob', ...config });
  }
};
